exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboarding-features-grid[data-v-455aff45] {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  max-width: 100%;\n}\n.onboarding-features-grid > *[data-v-455aff45] {\n    min-width: 0;\n}\n@media (max-width: 1024px) {\n.onboarding-features-grid[data-v-455aff45] {\n    grid-template-columns: repeat(2, 1fr);\n}\n}\n@media (max-width: 768px) {\n.onboarding-features-grid[data-v-455aff45] {\n    grid-template-columns: 1fr;\n    gap: 12px;\n}\n}\n", ""]);

// exports
